import { render, staticRenderFns } from "./ArticlePageBuilder.vue?vue&type=template&id=06435d1b"
import script from "./ArticlePageBuilder.vue?vue&type=script&lang=js"
export * from "./ArticlePageBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports